import { useEffect } from "preact/hooks";
import { useAppContext } from "@/hooks/useAppContext";
import Introduction from "@/modules/Introduction";
import QuestionWizard from "@/modules/QuestionWizard";
import Summary from "@/modules/Summary/Summary";
import { QuestionAnswer, Weights } from "@/types/questions";
import productsJson from "@/assets/content/products.json";
import questionsJson from "@/assets/content/questions.json";
import { trackStart } from "@/utils/adobeAnalytics";

const LearningCompass = () => {
  const {
    activeStep,
    setActiveStep,
    answers,
    products,
    setProducts,
    setQuestions,
  } = useAppContext();

  useEffect(() => {
    setProducts(productsJson.products);
    setQuestions(questionsJson.questions as any);
  }, []);

  const sumWeightsReducer = (
    acc: typeof products,
    item: QuestionAnswer[]
  ): typeof products => {
    const addWeights = (weights: Weights) => {
      Object.keys(weights).forEach((key) => {
        if (acc[key]) {
          acc[key].score += weights[key as keyof Weights];
        }
      });
    };

    item.forEach((qa: QuestionAnswer) => {
      addWeights(qa.weights);
    });

    return acc;
  };

  useEffect(() => {
    if (activeStep === 9) {
      const totalProductScores = Object.values(answers).reduce(
        sumWeightsReducer,
        {
          ...products,
        }
      );

      setProducts(totalProductScores);
    }
  }, [activeStep]);

  const handleStart = () => {
    trackStart();
    setActiveStep(1);
  };

  return (
    <div className="lc-bg-cfa-blue-950 lc-flex lc-justify-center lc-w-full lc-pt-11 lc-overflow-x-hidden">
      {activeStep === 0 && <Introduction onNext={handleStart} />}
      {activeStep > 0 && activeStep < 9 && <QuestionWizard />}
      {activeStep === 9 && <Summary products={products} answers={answers} />}
    </div>
  );
};

export default LearningCompass;
